<template>
    <div>
        <slot v-if="renderNavbar" name="navbar">
            <app-navbar :active.sync="showJoinModal" />
        </slot>
        <div class="section is-paddingless">
            <div class="is-marginless" :class="renderNavbar ? 'lb-main-layout' : 'lb-full-layout'">
                <div
                    v-if="$mq != 'mobile'"
                    class="lb-menu"
                >
                    <slot name="side-menu" />
                </div>
                <div class="lb-content">
                    <slot name="main-content" />
                </div>
            </div>
        </div>
        <!--<div class="copyright-section">
            <div class="legal-links secondary-font is-inline-block" v-html="$t('copyright_text')" />
            <div class="is-inline-block cookies secondary-font">
                | <a @click="showCookies">{{$t('modify_cookies')}}</a>
            </div>
        </div>-->
        <session-join-modal
            v-if="showJoinModal"
            @close="showJoinModal = false"
            @join="navigateToSession"
        />
    </div>
</template>

<script>
import AppNavbar from '@/components/AppNavbar';
import SessionJoinModal from '@/components/SessionJoinModal';
export default {
    components: {
        AppNavbar,
        SessionJoinModal,
    },
    data() {
        return {
            showJoinModal: false,
        };
    },
    /*computed: {
        cookiesAccepted(){
            console.log(this.$cookies.get("cookies-accepted"))
            return this.$cookies.get("cookies-accepted")
        }
    },*/
    methods: {
        navigateToSession({ code }) {
            this.$router.push({ name: 'play', query: { code } });
        },
        showCookies(){
            // console.log("removing cookie")
            /*this.$cookies.remove("cookies-accepted")
            console.log(this.$refs)*/
            this.$emit("show-cookies")
        },
    },
    props: {
        renderNavbar: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style scoped>
.lb-content {
    overflow-y: scroll;
    height: 100%;
}


</style>
